const LOGIN_EVENT_NAME = 'login_TOI_user';
const LOGOUT_EVENT_NAME = 'logout_TOI_user';
const FBLOGIN_EVENT_NAME = 'login_with_fb';
const GPLUSLOGIN_EVENT_NAME = 'login_with_google';
const CONSENT_GIVEN_EVENT_NAME = 'consent_given';
const GPLUSLOGIN_EVENT_NAME_FEDCM = 'login_with_google_fedcm';

export function loginEventEmitter(callback, dataObj, numberToPrefill) {
  const loginEvent = new Event(LOGIN_EVENT_NAME);
  if (typeof callback === 'function') {
    loginEvent.customCallBack = callback;
  }
  if (
    typeof dataObj !== 'undefined' &&
    dataObj.constructor === Object &&
    Object.keys(dataObj).length > 0
  ) {
    loginEvent.customDataObj = dataObj;
  }
  if (numberToPrefill !== undefined) {
    loginEvent.numberToPrefill = numberToPrefill;
  }

  window.dispatchEvent(loginEvent);
}

export function logOutEventEmitter(callback) {
  const logoutEvent = new Event(LOGOUT_EVENT_NAME);
  if (typeof callback === 'function') {
    logoutEvent.customCallBack = callback;
  }
  window.dispatchEvent(logoutEvent);
}

export function consentGivenEventEmitter() {
  const consentGivenEvent = new Event(CONSENT_GIVEN_EVENT_NAME);
  window.dispatchEvent(consentGivenEvent);
}

export function loginWithFBEventEmitter() {
  const fbLoginEvent = new Event(FBLOGIN_EVENT_NAME);
  window.dispatchEvent(fbLoginEvent);
}

export function loginWithGoogleEventEmitter() {
  const gplusLoginEvent = new Event(GPLUSLOGIN_EVENT_NAME);
  window.dispatchEvent(gplusLoginEvent);
}

export function loginWithGoogleEventEmitterFedcm(gisToken, clientId) {
  const gplusLoginEventFedcm = new Event(GPLUSLOGIN_EVENT_NAME_FEDCM);
  gplusLoginEventFedcm.gisToken = gisToken;
  gplusLoginEventFedcm.clientId = clientId;
  window.dispatchEvent(gplusLoginEventFedcm);
}
